import React from "react";
import { Box, Image } from "@chakra-ui/react";
const colorByStatus = {
    success: "green.600",
    error: "red.600",
    processing: "blue.600",
    warning: "yellow.500",
    inactive: "gray.400",
};
export function Tag({ imageUrl, children, status }) {
    return (React.createElement(Box, { as: "span", flex: "none", display: "inline-flex", alignItems: "center", bg: "gray.300", borderRadius: "full", height: 6, pl: imageUrl ? 0 : 2, pr: 2, gap: 1 },
        imageUrl && (React.createElement(Box, { display: "flex", boxSize: 6, bg: "white", borderRadius: "full", justifyContent: "center", alignItems: "center", border: "2px solid", borderColor: status ? colorByStatus[status] : "gray.300", padding: 1 },
            React.createElement(Image, { flex: "none", src: imageUrl, boxSize: 4, objectFit: "contain" }))),
        React.createElement(Box, { fontSize: "md", color: "gray.900" }, children)));
}
